import { RESOLUTION_TYPE } from "../constants";

export const AWAITING_REVIEW_STEPS = ["claim_filed", "decision", "resolved"];

export const RESOLUTION_STEP_KEYS: Record<string, string[]> = {
  [RESOLUTION_TYPE.REFUND]: ["claim_filed", "decision", "refund_issued"],
  [RESOLUTION_TYPE.STORE_CREDIT]: [
    "claim_filed",
    "decision",
    "store_credit_applied",
  ],
  [RESOLUTION_TYPE.RESHIP]: [
    "claim_filed",
    "decision",
    "reship_created",
    "reship_shipped",
    "reship_delivered",
  ],
  [RESOLUTION_TYPE.DEFAULT]: ["claim_filed", "decision", "resolved"],
};

/** Maps stepper step keys to possible timeline event keys from the API. */
export const TIMELINE_ALIASES: Record<string, string[]> = {
  claim_filed: ["claim_filed"],
  decision: ["approved", "denied"],
  refund_issued: ["refund_issued"],
  store_credit_applied: ["store_credit_applied"],
  reship_created: ["reship_created"],
  reship_shipped: ["reship_shipped"],
  reship_delivered: ["reship_delivered"],
  resolved: [
    "closed",
    "refund_issued",
    "store_credit_applied",
    "reship_delivered",
  ],
  denied: ["denied"],
};
